import script from "./digitalVideoMaker.vue?vue&type=script&setup=true&lang=ts"
export * from "./digitalVideoMaker.vue?vue&type=script&setup=true&lang=ts"

import "./digitalVideoMaker.vue?vue&type=style&index=0&id=3aa9772d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa9772d"]])

export default __exports__